import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Login from '../pages/Login/Login';
import ForgotPassword from '../pages/Login/ForgotPassword';
import OrderManagement from '../pages/Order/OrderManagement/OrderManagement';
import ReportDish from '../pages/Order/ReportDish/ReportDish';
import ReportRestaurant from '../pages/Order/ReportRestaurant/ReportRestaurant';

import NowPortalOrder from '../pages/NowPortal/NowPortalOrder/NowPortalOrder';
import NowPortalWithdraw from '../pages/NowPortal/NowPortalWithdraw/NowPortalWithdraw';

import NotFoundPage from '../components/NotFound/NotFoundPage';
import PrivateRoute from './PrivateRoute';
import SubMenuRoute from './SubMenuRoute';
import { withPermission } from '../authentication/AuthHOC';
import { trans } from '../localization';
import WalletManagement from '../pages/MerchantWallet/WalletManagement/WalletManagement';
import TableManagement from '../pages/Table/TableManagement/TableManagement';
import Dashboard from '../pages/Dashboard/Dashboard';
import ExportRestaurant from '../pages/Order/ExportRestaurant/ExportRestaurant';
import StaffManagement from '../pages/Staff/StaffManagement';
import AccountDeletion from '../pages/AccountDeletion';

const HomeRedirect = () => <Redirect to="/dashboard" />;

export const routesData = [
  {
    path: '/dashboard',
    to: '/dashboard',
    label: trans('menu_dashboard'),
    component: withPermission(Dashboard),
    exact: true,
    icon: 'icon-dashboard',
  },
  {
    path: '/order',
    to: '/order/order-management',
    label: trans('menu_order_management'),
    icon: 'icon-order',
    children: [
      {
        path: '/order/order-management',
        to: '/order/order-management',
        label: trans('menu_order_management'),
        component: withPermission(OrderManagement),
        exact: true,
      },
      {
        path: '/order/report-restaurant',
        to: '/order/report-restaurant',
        label: trans('menu_report_restaurant'),
        component: withPermission(ReportRestaurant),
        exact: true,
      },
      {
        path: '/order/report-dish',
        to: '/order/report-dish',
        label: trans('menu_report_dish'),
        component: withPermission(ReportDish),
        exact: true,
      },
      {
        path: '/order/export-restaurant',
        to: '/order/export-restaurant',
        label: trans('mod_export_restaurant'),
        component: withPermission(ExportRestaurant),
        exact: true,
      },
    ],
  },
  {
    path: '/table',
    to: '/table/table-management',
    label: trans('menu_table_management'),
    icon: 'icon-order',
    children: [
      {
        path: '/table/table-management',
        to: '/table/table-management',
        label: trans('menu_table_management'),
        component: withPermission(TableManagement),
        exact: true,
      },
    ],
  },
  {
    path: '/merchant-wallet',
    to: '/merchant-wallet/wallet-management',
    label: trans('menu_merchant_wallet'),
    icon: 'icon-wallet',
    children: [
      {
        path: '/merchant-wallet/wallet-management',
        to: '/merchant-wallet/wallet-management',
        label: trans('menu_wallet_management'),
        component: withPermission(WalletManagement),
        exact: true,
      },
      {
        path: '/merchant-wallet/history',
        to: '/merchant-wallet/history',
        label: trans('menu_portal_transaction_history'),
        component: withPermission(NowPortalOrder),
        exact: true,
      },
      {
        path: '/merchant-wallet/withdraw',
        to: '/merchant-wallet/withdraw',
        label: trans('menu_portal_withdraw'),
        component: withPermission(NowPortalWithdraw),
        exact: true,
      },
    ],
  },
  {
    path: '/staff',
    to: '/staff',
    label: trans('set_staff_manage_staff'),
    icon: 'icon-staff',
    component: withPermission(StaffManagement),
    exact: true,
  },
  {
    path: '/account-deletion',
    to: '/account-deletion',
    label:'',
    icon: 'icon-staff',
    component: AccountDeletion,
    exact: true,
    hide:true
  },
  // {
  //   path: '/menu',
  //   to: '/menu/dish',
  //   label: trans('menu_menu_management'),
  //   icon: 'icon-menu-manage',
  //   children: [
  //     {
  //       path: '/menu/dish',
  //       to: '/menu/dish',
  //       label: trans('menu_menu_dish'),
  //       component: null,
  //       exact: true,
  //     },
  //     {
  //       path: '/menu/topping',
  //       to: '/menu/topping',
  //       label: trans('menu_menu_topping'),
  //       component: null,
  //       exact: true,
  //     },
  //   ],
  // },
  // {
  //   path: '/profile',
  //   to: '/profile',
  //   label: trans('profile'),
  //   icon: 'icon-profile',
  //   component: null,
  //   exact: true,
  // },
];

const routes = (
  <section className="main-content">
    <Switch>
      <Route exact path="/account/login" component={Login} />
      <Route exact path="/account/forgot-password" component={ForgotPassword} />
      {routesData.map((route) => {
        const {
          path,
          component = SubMenuRoute,
          exact = false,
        } = route;
        return (
          <PrivateRoute
            path={path}
            component={component}
            exact={exact}
            key={path}
          />
        );
      })}
      <PrivateRoute exact path="/" component={HomeRedirect} />
      <Route path="/" component={NotFoundPage} />
    </Switch>
  </section>
);

export default routes;



// WEBPACK FOOTER //
// ./foody/src/routes/routes.jsx